import { Fragment } from 'react'
import { useRouter } from 'next/router'
import { isEmpty } from 'lodash-es'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

import { stringify } from 'qs'
import Link from 'components/common/A'
import { HideInMobileBox } from 'components/common/Hidden'

const ImgRect = styled.div`
  ${({ theme, $usedInVenderPage }) => `
    position: relative;
    padding-top: 100%;

    ${theme.breakpoints.up($usedInVenderPage ? 'md' : 'lg')} {
      padding-top: 75%;
    }
  `}
`
const Absolute = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: url('/img/img_headshot_default.png');
  background-size: 100%;
  background-position: center;
`

const getLinkFilterByTag = (tagUrlId, extraRouteParams) => {
  const params = { ...extraRouteParams, tag: tagUrlId }
  return `/album?${stringify(params)}`
}

const Album = ({
  album,
  onClick,
  onAlbumTagClick,
  extraRouteParams,
  usedInVenderPage,
}) => {
  const photo = album?.representativePhotoInfo || album?.frontCover
  const image = photo?.image
  const tags = photo?.tags

  const router = useRouter()
  const albumLink =
    `/album/${album.urlId?.toLowerCase?.()}` +
    (isEmpty(extraRouteParams) ? '' : `?${stringify(extraRouteParams)}`)
  const onAlbumClick = (e) => {
    if (onClick) {
      onClick(e, album)
    } else {
      router.push(albumLink)
    }
  }

  const onTagClick = (e, tag) => {
    e.preventDefault()
    e.stopPropagation()
    if (onAlbumTagClick) {
      onAlbumTagClick(tag)
    } else {
      router.push(getLinkFilterByTag(tag.urlId, extraRouteParams))
    }
  }

  return (
    <Box display="flex" flexDirection="column" mb={0}>
      <Link $origin href={albumLink} onClick={onAlbumClick}>
        <div>
          <ImgRect $usedInVenderPage={usedInVenderPage}>
            <Absolute>
              <Img src={image?.url} alt={album.name} />
            </Absolute>
          </ImgRect>
        </div>
        <Typography>
          <Box fontWeight="fontWeightBold" mt={3}>
            {album.name}
          </Box>
        </Typography>
      </Link>
      {!!tags?.length && (
        <Box
          mt={2}
          sx={{
            display: {
              xs: 'none',
              ...(usedInVenderPage ? { md: 'block' } : { lg: 'block' }),
            },
          }}
        >
          {tags?.map((tag, index) => (
            <Fragment key={tag.urlId}>
              {index > 0 && (
                <Box mx={2.5} component="span" color="text.secondary">
                  |
                </Box>
              )}
              <Link
                $textSecondary
                $nowrap
                href={getLinkFilterByTag(tag.urlId, extraRouteParams)}
                onClick={(e) => onTagClick(e, tag)}
              >
                {tag.name}
              </Link>
            </Fragment>
          ))}
        </Box>
      )}
    </Box>
  )
}

Album.defaultProps = {
  extraRouteParams: {},
}

export default Album
